import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrow, rightArrowHover, services1, services2, services3, services4, services5, services6, services7, services8, services9, servicesPattern, whyUs } from '../../../assets/images';
import { motion, AnimatePresence } from 'framer-motion';
import AOS from 'aos';
import 'aos/dist/aos.css';


const Services = () => {

      const { t } = useTranslation();

        useEffect(() => {
              AOS.init({ duration: 2000, once: false }); 
            }, []);
 
      const services = [
        {
          id: 1,
          img: services1,
          title: 'İsitmə',
          description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Məqsədimiz, müasir texnologiyalar və keyfiyyətli xidmət sayəsində müştərilərimizə komfortlu və təhlükəsiz mühit yaratmaqdır.',
        },
        {
          id: 2,
          img: services2,
          title: 'Ventilyasiya',
          description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Məqsədimiz, müasir texnologiyalar və keyfiyyətli xidmət sayəsində müştərilərimizə komfortlu və təhlükəsiz mühit yaratmaqdır.',
        },
        {
          id: 3,
          img: services3,
          title: 'Soyutma, kondisionerləşdirmə',
          description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Məqsədimiz, müasir texnologiyalar və keyfiyyətli xidmət sayəsində müştərilərimizə komfortlu və təhlükəsiz mühit yaratmaqdır.',
        },
        {
            id: 4,
            img: services4,
            title: 'Santexnika',
            description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Məqsədimiz, müasir texnologiyalar və keyfiyyətli xidmət sayəsində müştərilərimizə komfortlu və təhlükəsiz mühit yaratmaqdır.',
          },
          {
            id: 5,
            img: services5,
            title: 'Yanğınsöndürmə',
            description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Məqsədimiz, müasir texnologiyalar və keyfiyyətli xidmət sayəsində müştərilərimizə komfortlu və təhlükəsiz mühit yaratmaqdır.',
          },
          {
            id: 6,
            img: services6,
            title: 'Elektrik sistemləri',
            description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Məqsədimiz, müasir texnologiyalar və keyfiyyətli xidmət sayəsində müştərilərimizə komfortlu və təhlükəsiz mühit yaratmaqdır.',
          },
          {
            id: 7,
            img: services7,
            title: 'Aşağı cərəyan',
             description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Məqsədimiz, müasir texnologiyalar və keyfiyyətli xidmət sayəsində müştərilərimizə komfortlu və təhlükəsiz mühit yaratmaqdır.',
          },
          {
            id: 8,
            img: services8,
            title: 'Avtomatlaşdırma sistemləri',
             description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Məqsədimiz, müasir texnologiyalar və keyfiyyətli xidmət sayəsində müştərilərimizə komfortlu və təhlükəsiz mühit yaratmaqdır.',
          },
          {
            id: 9,
            img: services9,
            title: 'Kanal sexi',
            description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq. Məqsədimiz, müasir texnologiyalar və keyfiyyətli xidmət sayəsində müştərilərimizə komfortlu və təhlükəsiz mühit yaratmaqdır.',
          },
      ];

      const [selectedService, setSelectedService] = useState(services[0]);
            const [dropdownOpen, setDropdownOpen] = useState(false);


  return ( 
    <div data-aos="fade-up" className='mt-[88px] md:mt-[104px] bg-[#01A396] relative'>
      <img
    src={servicesPattern} // buraya kendi transparent image dosyanın yolunu koy
    alt="overlay"
    className="absolute top-0 left-0 w-full h-full object-cover opacity-10 z-0"
  />

        <div className='max-w-containerSm md:max-w-container mx-auto'>
        <div>
        <p className='text-[24px] md:text-[32px] font-medium text-[white] pt-[45px]'>{t("Xidmətlər")}</p>
        </div>
        <div className='md:flex justify-between items-center mt-[32px] pb-[45px]'>
      {/* Sol Kategori Listesi */} 
      <div className='md:w-[30%] hidden md:flex flex-col gap-3 z-20'>
        {services.map((card, index) => (
          <div
            key={index}
            onClick={() => setSelectedService(card)}
            className={`w-full cursor-pointer px-4 py-3 rounded-lg font-medium bg-white ${
              selectedService.title === card.title ? 'text-[#01A396]' : 'text-[#1C1C1C]'
            }`}
          >
            {card.title}
          </div>
        ))}
      </div>
      <div className="md:hidden z-30 relative w-full">
  <button
    onClick={() => setDropdownOpen(!dropdownOpen)}
    className="w-full px-4 py-3 rounded-lg border border-gray-300 text-[#1C1C1C] bg-white flex justify-between items-center"
  >
    {selectedService.title}
    <svg
      className={`w-4 h-4 transition-transform ${dropdownOpen ? 'rotate-180' : ''}`}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  {dropdownOpen && (
  <div className="absolute top-full left-0 w-full bg-white border border-gray-300 rounded-lg mt-2 z-40 px-2 py-2">
    <div className="flex flex-col space-y-2">
      {services.map((service, index) => (
        <div
          key={index}
          onClick={() => {
            setSelectedService(service);
            setDropdownOpen(false);
          }}
          className={`px-4 py-2 cursor-pointer hover:bg-gray-100 rounded-md ${
            selectedService.title === service.title ? 'bg-[#01A396] text-white font-medium' : ''
          }`}
        >
          {service.title}
        </div>
      ))}
    </div>
  </div>
)}


</div>

      {/* Sağ İçerik */}
<div className='relative md:flex flex-col md:flex-row items-center mt-8 md:mt-0 md:w-[60%]'>
  {/* Görsel */}
  <AnimatePresence mode="wait">
    <motion.div
      key={selectedService.id + "-img"}
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -50 }}
      transition={{ duration: 0.4 }}
      className='md:w-[55%] ml-auto z-0'
    >
      <img className='w-full h-full object-cover' src={selectedService?.img} />
    </motion.div>
  </AnimatePresence>

  {/* Metin Kutusu */}
  <AnimatePresence mode="wait">
    <motion.div
      key={selectedService.id + "-text"}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -30 }}
      transition={{ duration: 0.4 }}
      className='relative z-10 w-full md:w-[55%] h-auto bg-white py-5 px-6 border border-[#E5E5E5] rounded-[12px] 
      -mt-10 md:mt-0 md:absolute md:left-0'
    >
      <p className='text-[#1C1C1C] font-medium text-[18px] md:text-[24px]'>{selectedService?.title}</p>
      <p className='mt-6 text-[#1C1C1C]'>{selectedService?.description}</p>

      <a className='group' href={`services/${selectedService?.id}`}>
        <div className='flex items-center mt-6 justify-between w-[100px] mx-auto md:mx-0 rounded-[12px] bg-white text-[#1C1C1C] h-[46px]'>
          <p className='transition-colors duration-300 group-hover:text-[#008A7F]'>Ətraflı</p>
          <img className='w-2 transition-opacity duration-300 group-hover:hidden' src={rightArrow} alt="" />
          <img className='w-2 transition-opacity duration-300 hidden group-hover:block' src={rightArrowHover} alt="" />
        </div>
      </a>
    </motion.div>
  </AnimatePresence>
</div>

    </div>


    </div>
    </div>
  )
}

export default Services